angular.module("app")

/**
 * This directive displays a map.
 * Onto the map, directive draws data accordingly to a scope watched attibute.
 */
	.directive("tchOlMap", [
		"MapService", "CONSTANTS", "$timeout",
		function (MapService, CONSTANTS, $timeout) {

		var id = 0;
		var MAP_DOM_ELEMENT_ID = "tchMap";
		var map;

		/**
		 *Generates a unique ID for the dom map element.
		 * @returns {string}
		 */
		function getId() {
			return MAP_DOM_ELEMENT_ID + (++id);
		}


		/**
		 * Creates the map and center it on Paris.
		 * Adds a base layer.
		 * @param id
		 * @returns {OpenLayers.Map}
		 */
		function createAndCenterMap(id) {
			var options = {
				projection: "EPSG:3857"
			};
			var map = new OpenLayers.Map(id, options);

			var layerOption = {
				layers: "satellite"
			};

			map.addLayer( new OpenLayers.Layer.OSM());
			// URL WMS SATELLITE
			map.addLayer( new OpenLayers.Layer.WMS( "Satellite", "https://tile.geobretagne.fr/gwc02/service/wms", layerOption));

			map.setCenter( new OpenLayers.LonLat(2.3514616, 48.8566969).transform(CONSTANTS.MAP_FROM_PROJECTION, CONSTANTS.MAP_TO_PROJECTION), 9);

			var layerSwitcherOptions = {

			};
			var layerSwitcher = new OpenLayers.Control.LayerSwitcher( layerSwitcherOptions);
			map.addControl( layerSwitcher);

			return map;
		}


		return {

			restrict: "E",

			replace: true,

			template: "<div id=\"{{id}}\" class=\"full-height\"></div>",

			scope: {

				/**
				 * A scope attibute that will be watched to relaod the map as soon as it changes.
				 */
				trace: "=tchOlMapTrace",

				/**
				 * An html template that will be used to display clicked points data.
				 */
				featuresPopupTemplate: "=tchOlMapFeaturesPopupTemplate",

				/**
				 * Cakkback object that can be used in the parent controller to refer to map ofeatures created by the directive.
				 */
				features: "=tchOlMapFeatures", // callback object to intercat with the map.

				/**
				 * Callback called whenever a point is clicked on the map.
				 */
				mapCallback: "&tchOlMapRefreshedCallback",

				/**
				 * A linkk o the map itself, so we can manipulate it from the parent controller.
				 */
				map: "=tchOlMapMap"
			},

			link: function postLink(scope) {

				scope.id = getId();

				$timeout(function () {

					// store a reference to the map in parent scope
					var map = createAndCenterMap(scope.id);
					if (scope.map) {
						scope.map = map;
					}


					//watch data to draw, redraw when it changes
					scope.$watch("trace", function (trace, oldTrace) {
						//if (trace !== oldTrace) {
						MapService.clearMapUserLayers(map);

						// Draw each path, and store a reference by ID to the created vectors if tch-ol-map-features attribute is present
						for (var i = 0; i < trace.length; i++) {
							var currentTrace = trace[i];
							var createdFeatures = MapService.drawPathWithPoints(map, currentTrace.journeyPatternId, currentTrace.stopPoints, currentTrace.color, currentTrace.showPoints, currentTrace.showPath, {
								featuresPopupTemplate: scope.featuresPopupTemplate,
								zoomWhenDone: currentTrace.zoomWhenDone,
								drawPath: currentTrace.drawPath,
								drawPoints: currentTrace.drawPoints,
								showStartAndEndPoints: currentTrace.showStartAndEndPoints,
								featuresCallBackFunction: currentTrace.clickFunction,
								draggable: currentTrace.draggable,
								draggableFeatureCallbackFunction: currentTrace.draggableFeatureCallbackFunction
							});

							// store a refrence to created features
							if (scope.features) {
								scope.features[currentTrace.id] = createdFeatures;
							}

							//}
						}
					});


					// On first draw and map extent changes (pan or zoom), call optional callback function on parent controller.
					if (scope.mapCallback) {

						// first call
						scope.mapCallback({
							bounds: map.getExtent().transform(CONSTANTS.MAP_TO_PROJECTION, CONSTANTS.MAP_FROM_PROJECTION)
						});

						// listen to map changes to call function
						map.events.register("moveend", null, function () {
							scope.mapCallback({
								bounds: map.getExtent().transform(CONSTANTS.MAP_TO_PROJECTION, CONSTANTS.MAP_FROM_PROJECTION)
							});
						});
					}
				});
			}

		};

	}]);
